import moment from 'moment'
import md5 from 'md5'

export function getSign () {
  const timestamp = moment().unix()
  const salt = process.env.VUE_APP_REQUEST_SALT
  const sign = md5(timestamp + salt)
  return { timestamp, sign }
}